import { render, staticRenderFns } from "./Restriction.vue?vue&type=template&id=319b9058&scoped=true&"
import script from "./Restriction.vue?vue&type=script&lang=js&"
export * from "./Restriction.vue?vue&type=script&lang=js&"
import style0 from "./Restriction.vue?vue&type=style&index=0&id=319b9058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b9058",
  null
  
)

export default component.exports